import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import { useTheme } from '@components/theme';
import breakpoints from '@constants/breakpoints';
import { IPrismicImage } from '@lib/prismic/types';
import React, { useContext } from 'react';
import classNames from 'classnames';
import UserContext from '@context/User/user-context';
import styles from './GetStarted.module.scss';

interface IGetStarted {
  className?: string;
  image: IPrismicImage;
  eyebrow: string;
  title: string;
  description: string;
  ctaText: string;
  ctaLink: string;
  ctaLoggedInLink: string;
}

const mobileBreakpoint = breakpoints.desktop;
const tabletBreakpoint = breakpoints['medium-tablet'];

export default function GetStarted({
  className = '',
  image,
  eyebrow,
  title,
  description,
  ctaText,
  ctaLink,
  ctaLoggedInLink,
}: IGetStarted) {
  const theme = useTheme();
  const { user } = useContext(UserContext);

  return (
    <div
      className={`${styles.Root} ${className}`}
    >
      <div className={styles.Image}>
        <PrismicImage
          image={image}
          breakpoints={{
            mobile: mobileBreakpoint,
            tablet: tabletBreakpoint,
          }}
        />
      </div>
      <div className={styles.TextCard}>
        <h2
          className={`${styles.Overline} ${styles.Contrast} ${theme.styles.Overline}`}
          style={{ color: theme.colors.core2 }}
        >
          {eyebrow}
        </h2>

        <h4
          className={`${styles.Header} ${styles.Core2} ${theme.styles.Header}`}
          style={{ color: theme.colors.core2 }}
        >
          {title}
        </h4>
        <p
          className={`${theme.styles.Body} ${styles.Body}
          ${styles.Contrast}`}
          style={{ color: theme.colors.core2 }}
        >
          {description}
        </p>
        <div className={styles.Container}>
          <a
            className={classNames(theme.styles.Button, theme.styles.Conflicting)}
            href={user && ctaLoggedInLink ? ctaLoggedInLink : ctaLink}
          >
            {ctaText}
          </a>
        </div>
      </div>
    </div>
  );
}
